export const PlansRoutes = [
  {
    path: "plans",
    name: "plans",
    component: () => import("@/domain/Plans/presentation/pages/PlansListPage.vue"),
    meta: { requiresAuth: true, permissions: "organizations.read" },
  },
  {
    path: "plan/:id",
    name: "editPlan",
    component: () => import("@/domain/Plans/presentation/pages/PlanDetailPage.vue"),
    meta: { requiresAuth: true, permissions: "organizations.read" },
  },
];
